import { render, staticRenderFns } from "./InstructionsForm.vue?vue&type=template&id=68d853b5&scoped=true&"
import script from "./InstructionsForm.vue?vue&type=script&lang=js&"
export * from "./InstructionsForm.vue?vue&type=script&lang=js&"
import style0 from "./InstructionsForm.vue?vue&type=style&index=0&id=68d853b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d853b5",
  null
  
)

export default component.exports